module.exports = __webpack_public_path__ + "static/media/cover_maths_7_8_degree.b2d0978c.jpg";